import React, { useState } from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Shield } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminAuth = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [credentials, setCredentials] = useState({
    email: '',
    password: ''
  });

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      console.log('🔐 Tentative de connexion admin avec:', { email: credentials.email });
      console.log('🌐 API URL:', `${API}/admin/login`);
      
      const response = await axios.post(`${API}/admin/login`, credentials);
      console.log('✅ Réponse reçue:', response.data);
      
      toast.success('Connexion admin réussie!');
      localStorage.setItem('admin_token', response.data.token);
      navigate('/admin/dashboard');
    } catch (error) {
      console.error('❌ Erreur de connexion:', error);
      console.error('❌ Détails erreur:', error.response?.data);
      toast.error(error.response?.data?.detail || 'Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 to-slate-800 flex items-center justify-center py-12 px-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-red-600 rounded-2xl mb-4">
            <Shield className="h-8 w-8 text-white" strokeWidth={2} />
          </div>
          <h1 
            className="text-3xl font-bold text-white" 
            style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}
            data-testid="admin-auth-title"
          >
            Administration Mosala.cd
          </h1>
          <p className="text-slate-300 mt-2">Accès réservé aux administrateurs</p>
        </div>

        {/* Auth Card */}
        <Card className="p-8 shadow-xl bg-slate-800 border-slate-700">
          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <Label htmlFor="admin-email" className="text-slate-200">Email Administrateur</Label>
              <Input
                id="admin-email"
                type="email"
                placeholder="admin@mosala.cd"
                value={credentials.email}
                onChange={(e) => setCredentials({ ...credentials, email: e.target.value })}
                required
                className="mt-1 bg-slate-700 border-slate-600 text-white"
                data-testid="admin-email-input"
              />
            </div>
            <div>
              <Label htmlFor="admin-password" className="text-slate-200">Mot de passe</Label>
              <Input
                id="admin-password"
                type="password"
                placeholder="••••••••"
                value={credentials.password}
                onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                required
                className="mt-1 bg-slate-700 border-slate-600 text-white"
                data-testid="admin-password-input"
              />
            </div>
            <Button 
              type="submit" 
              className="w-full bg-red-600 hover:bg-red-700 text-white rounded-full py-6 font-semibold"
              disabled={loading}
              data-testid="admin-login-submit-button"
            >
              {loading ? 'Connexion...' : 'Se connecter'}
            </Button>
          </form>
        </Card>

        <p className="text-center text-sm text-slate-400 mt-6">
          Dashboard sécurisé avec accès contrôlé
        </p>
      </div>
    </div>
  );
};

export default AdminAuth;
